import React from 'react';
import twitterDynamic from 'assets/svg/twitter_dynamic.svg';
import facebookDynamic from 'assets/svg/facebook_dynamic.svg';
import instagramDynamic from 'assets/svg/instagram_dynamic.svg';
import tiktokDynamic from 'assets/svg/tiktok_dynamic.svg';
import linkedInDynamic from 'assets/svg/linkedin_dynamic.svg';
import style from './social-links.scss';
const SOCIAL_ICONS = {
  twitter: twitterDynamic,
  facebook: facebookDynamic,
  instagram: instagramDynamic,
  tiktok: tiktokDynamic,
  linkedIn: linkedInDynamic
};
export function SocialLinksComponent({
  socials,
  showDivider = true
}) {
  if (!socials || socials.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style.socialsWrapper
  }, showDivider && /*#__PURE__*/React.createElement("div", {
    className: style.divider
  }), /*#__PURE__*/React.createElement("div", {
    className: style.socials
  }, socials.map(social => {
    return /*#__PURE__*/React.createElement("a", {
      key: social.url,
      href: social.url,
      target: "_blank",
      rel: "noreferrer noopener"
    }, /*#__PURE__*/React.createElement("img", {
      src: SOCIAL_ICONS[social.name],
      alt: "logo"
    }));
  })));
}